/**
 * Global Axios CSRF configuration.
 * Import this file once (early in the app) to enable automatic
 * XSRF-TOKEN cookie → X-XSRF-TOKEN header on every request.
 *
 * Axios has built-in support for this — we just need to configure the
 * cookie/header names and enable credentials.
 */
import axios from 'axios';

// Multi-tenant: use current origin when on a tenant subdomain
// window.__BACKEND_URL is set by index.html before React loads
export const getBackendUrl = () => window.__BACKEND_URL || process.env.REACT_APP_BACKEND_URL || '';

// Tell axios to read the XSRF-TOKEN cookie and send it as X-XSRF-TOKEN header
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.withCredentials = true;

// Set baseURL so all axios calls without full URL go to the right host
const base = getBackendUrl();
if (base) axios.defaults.baseURL = base;

// Interceptor: rewrite absolute URLs that point to the build-time backend
// to the correct tenant origin. This fixes all 135+ places that use
// `${process.env.REACT_APP_BACKEND_URL}/api/...` without needing to edit them.
const buildTimeUrl = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
if (window.__BACKEND_URL && buildTimeUrl && window.__BACKEND_URL !== buildTimeUrl) {
  // Axios interceptor
  axios.interceptors.request.use((config) => {
    if (config.url && config.url.startsWith(buildTimeUrl)) {
      config.url = config.url.replace(buildTimeUrl, window.__BACKEND_URL);
    }
    return config;
  });

  // Native fetch() wrapper — rewrites URLs for raw fetch calls
  const _originalFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    if (typeof input === 'string' && input.startsWith(buildTimeUrl)) {
      input = input.replace(buildTimeUrl, window.__BACKEND_URL);
    }
    return _originalFetch(input, init);
  };
}
